var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ma-0",attrs:{"label":"Escolha o Departamento","items":_vm.items,"loading":_vm.loadingValue,"disabled":_vm.isDisabled,"dark":_vm.dark},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }